<template>
  <span>
    <b-modal @hidden="resetModal" ref="modal-container" v-model="modalShow" size="lg" static lazy hide-footer>
      <template #modal-title="">
        <i class="fas fa-plus"/>&nbsp;Assign player
      </template>
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <div v-for="({id, label, required, type, options = null}) in inputs" :key="id">
        <b-form-group :label="label" :label-for="`${id}-input`" v-if="isVisible(id)">
          <b-form-input v-if="type === 'string'"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <b-form-input v-if="type === 'multiselect'"
                        hidden
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <multiselect  v-if="type === 'multiselect'"
                        v-model="formValues[id]"
                        :options="options"
                        label="label"
                        :id="`${id}-input`"
                        track-by="value"
                        :multiple="false"
                        :placeholder="'Select ' + label"
          />
          <b-form-input v-if="type === 'number'"
                        type="number"
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <b-form-select
              v-if="type === 'select'"
              :id="`${id}-input`"
              v-model="formValues[id]" v-validate="{ required: required }"
              :options="options.map(o => { return {value: o, text: o ? o : ''}})"
              :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
              :data-vv-as="label" autocomplete="off"
          />
          <b-form-input v-if="type === 'datetime'"
                        hidden
                        :id="`${id}-input`"
                        v-model="formValues[id]" v-validate="{ required: required }"
                        :state="validateState(id)" :aria-describedby="`${id}-live-feedback`" :data-vv-name="id"
                        :data-vv-as="label" autocomplete="off"
          />
          <DatePicker
              v-if="type === 'datetime'"
              :id="`${id}-input`"
              input-class="form-control"
              type="datetime"
              v-model="formValues[id]"
              valueType="format"
              :placeholder="label"
              :shortcuts="dateShortcuts"
          />
          <b-form-invalid-feedback :id="`${id}-live-feedback`">{{ veeErrors.first(id) }}</b-form-invalid-feedback>
        </b-form-group>
        </div>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit" :disabled="isLoading">Add</b-button>
    </b-modal>
  </span>
</template>

<style>
.is-invalid~.multiselect .multiselect__tags {
  border-color: red;
}
.is-invalid~.mx-datepicker input {
  border-color: red;
}
</style>

<script>
import Vue from "vue";
import {getRouteIcon, ROUTE_TOMHORN_FREESPINS} from "../../utils/routerIcons";
import DatePicker from 'vue2-datepicker';
import {getFilterShortcuts} from "../../utils/dateUtils";
import Multiselect from "vue-multiselect";

export default {
  components: {
    DatePicker,
    Multiselect
  },
  data() {
    return {
      operatorOptions: [],
      modalShow: false,
      formValues: this.getInitialValues(),
      isLoading: false,
      dateShortcuts: getFilterShortcuts(),
    }
  },
  props: {
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        players: null,
        campaign: null,
        currency: null,
      };
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    showModal(data) {
      this.resetModal();

      if (data) {
        this.formValues = {
          ...data,
          operatorId: data.operatorId ? this.operatorOptions.find((operatorOption) => operatorOption.value === data.operatorId) : null
        }
      }

      this.modalShow = true
    },
    handleSubmit() {
      this.inputs.forEach(({id, type}) => {
        if (type === 'string' && this.formValues[id] !== null) {
          this.formValues[id] = this.formValues[id].trim();
        }
      })
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        if (this.isLoading) {
          return;
        }

        this.isLoading = true;

        this
            .$http({
              url: '/api/v1/tomhorn-freespins/assign',
              method: 'POST',
              data: {
                ...this.formValues,
              },
              headers: {'Content-Type': 'application/json'},
            })
            .then(() => {
              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              let message;

              if (typeof err.response.data.message === 'string') {
                message = err.response.data.message;
              } else {
                message = JSON.stringify(err.response.data.message);
              }

              this.$toastr.e(message);

              throw err;
            })
            .finally(() => {
              this.isLoading = false;
            });
      });
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    isVisible(id) {
      if (id === 'count') {
        return this.formValues.type === 'regular'
      }
      if (id === 'stake') {
        return this.formValues.type === 'regular'
      }
      if (id === 'value') {
        return this.formValues.type === 'variable'
      }
      return true;
    }
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_TOMHORN_FREESPINS),
    inputs() {
      return [
        {id: 'players', label: 'Players', required: true, type: 'string'},
        {id: 'campaign', label: 'Campaign', required: true, type: 'string'},
        {id: 'currency', label: 'Currency', required: true, type: 'string'},
      ]
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
